import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Courses.css'; // Import the custom CSS file
import BannerUpdate from '../../components/BannerUpdate/BannerUpadate';
import API_URL from '../../api/ExamCalendarApi';

const Courses = () => {
  const [courses, setCourses] = useState([]);
  const [courseName, setCourseName] = useState('');
  const [medium, setMedium] = useState('');
  const [mode, setMode] = useState('');
  const [category, setCategory] = useState('');
  const [description, setDescription] = useState('');
  const [bannerImg, setBannerImg] = useState(null);
  const [editId, setEditId] = useState(null);
  const [error, setError] = useState(null); // State for error handling
  const [loading, setLoading] = useState(false); // State for loading
  const [successMessage, setSuccessMessage] = useState(null); // State for success message

  useEffect(() => {
    fetchCourses();
  }, []);

  const fetchCourses = async () => {
    try {
      const response = await axios.get(`${API_URL}/course/all`);
      setCourses(response.data);
    } catch (error) {
      console.error('Error fetching courses:', error);
      setError('Failed to load courses');
    }
  };

  const handleFileChange = (e) => {
    setBannerImg(e.target.files[0]);
  };

  const handleDropdownChange = (e, setter) => {
    setter(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);  // Show loading spinner
    setSuccessMessage(null);  // Reset success message
    setError(null); // Reset error message

    const formData = new FormData();
    formData.append('courseName', courseName);
    formData.append('medium', medium);
    formData.append('mode', mode);
    formData.append('category', category);
    formData.append('description', description);
    if (bannerImg) {
      formData.append('bannerImg', bannerImg);
    }

    try {
      if (editId) {
        await axios.put(`${API_URL}/course/edit/${editId}`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        setEditId(null);
        setSuccessMessage('Course updated successfully!');
      } else {
        await axios.post(`${API_URL}/course/add`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        setSuccessMessage('Course added successfully!');
      }

      // Reset form fields after submission
      setCourseName('');
      setMedium('');
      setMode('');
      setCategory('');
      setDescription('');
      setBannerImg(null);
      fetchCourses();
    } catch (error) {
      console.error('Error submitting course:', error);
      setError('Failed to submit course');
    } finally {
      setLoading(false);  // Hide loading spinner
    }
  };

  const handleEdit = (course) => {
    setCourseName(course.courseName);
    setMedium(course.medium);
    setMode(course.mode);
    setCategory(course.category);
    setDescription(course.description);
    setEditId(course._id);
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${API_URL}/course/delete/${id}`);
      fetchCourses();
      setSuccessMessage('Course deleted successfully!');
    } catch (error) {
      console.error('Error deleting course:', error);
      setError('Failed to delete course');
    }
  };

  return (
    <div className="admin-courses-container">
      <div className="admin-courses-section">
        <h2>Manage Courses</h2>
        <BannerUpdate pageName="courses" />

        {/* Success Message */}
        {successMessage && <div className="admin-courses-alert admin-courses-alert-success">{successMessage}</div>}

        {/* Error Message */}
        {error && <div className="admin-courses-alert admin-courses-alert-danger">{error}</div>}

        {/* Form to add/update a course */}
        <form className="admin-courses-form" onSubmit={handleSubmit}>
          <div className="admin-courses-form-group">
            <label htmlFor="courseName" className="admin-courses-form-label">Course Name</label>
            <input
              type="text"
              className="admin-courses-form-control"
              id="courseName"
              value={courseName}
              onChange={(e) => setCourseName(e.target.value)}
              required
            />
          </div>

          {/* Medium dropdown */}
          <div className="admin-courses-form-group">
            <label htmlFor="medium" className="admin-courses-form-label">Medium</label>
            <select
              id="medium"
              className="admin-courses-form-select"
              value={medium}
              onChange={(e) => handleDropdownChange(e, setMedium)}
              required
            >
              <option value="">Select Medium</option>
              <option value="ENGLISH/TELUGU">ENGLISH/TELUGU</option>
              <option value="ENGLISH">ENGLISH</option>
              <option value="TELUGU">TELUGU</option>
            </select>
          </div>

          {/* Mode dropdown */}
          <div className="admin-courses-form-group">
            <label htmlFor="mode" className="admin-courses-form-label">Mode</label>
            <select
              id="mode"
              className="admin-courses-form-select"
              value={mode}
              onChange={(e) => handleDropdownChange(e, setMode)}
              required
            >
              <option value="">Select Mode</option>
              <option value="online">Online</option>
              <option value="offline">Offline</option>
            </select>
          </div>

          {/* Category dropdown */}
          <div className="admin-courses-form-group">
            <label htmlFor="category" className="admin-courses-form-label">Category</label>
            <select
              id="category"
              className="admin-courses-form-select"
              value={category}
              onChange={(e) => handleDropdownChange(e, setCategory)}
              required
            >
              <option value="">Select Category</option>
              <option value="GOVERNMENT JOBS">GOVERNMENT JOBS</option>
              <option value="STATE PSC EXAMS">STATE PSC EXAMS</option>
            </select>
          </div>

          {/* Description input */}
          <div className="admin-courses-form-group">
            <label htmlFor="description" className="admin-courses-form-label">Description</label>
            <textarea
              className="admin-courses-form-control"
              id="description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              required
            />
          </div>

          {/* Banner Image upload */}
          <div className="admin-courses-form-group">
            <label htmlFor="bannerImg" className="admin-courses-form-label">Banner Image</label>
            <input
              type="file"
              className="admin-courses-form-control"
              id="bannerImg"
              onChange={handleFileChange}
            />
          </div>

          <button type="submit" className="admin-courses-btn" disabled={loading}>
            {loading ? 'Submitting...' : editId ? 'Update' : 'Add'} Course
          </button>
        </form>

        {/* List of courses */}
        <h3 className="admin-courses-list-title">Existing Courses</h3>
        <div className="admin-courses-table-wrapper">
          <table className="admin-courses-table">
            <thead>
              <tr>
                <th>Course Name</th>
                <th>Medium</th>
                <th>Mode</th>
                <th>Category</th>
                <th>Description</th>
                <th>Banner Image</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {courses.map((course) => (
                <tr key={course._id}>
                  <td>{course.courseName}</td>
                  <td>{course.medium}</td>
                  <td>{course.mode}</td>
                  <td>{course.category}</td>
                  <td>{course.description}</td>
                  <td>
                    {course.bannerImg && <img src={course.bannerImg} alt="Banner" width="100" />}
                  </td>
                  <td>
                    <button className="admin-courses-btn-edit" onClick={() => handleEdit(course)}>Edit</button>
                    <button className="admin-courses-btn-delete" onClick={() => handleDelete(course._id)}>Delete</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Courses;
